import {
	Home,
	LayoutDashboard,
	UserSquare2,
	PiggyBank,
	HandCoins,
	Banknote,
	FileText,
	Settings,
	ShieldCheck,
	UserCog,
	User,
	FileSpreadsheet,
	FilePlus,
	ClipboardList,
	LineChart,
	ReceiptText,
	Building2,
	UserCheck,
	Users2,
	FileSearch,
	Cog,
} from 'lucide-react';
import { IRoute } from './types';

export default function useDashboardRoutes() {
	const routes: IRoute[] = [
		{
			key: 'welcome',
			label: 'Welcome',
			path: '/dashboard/cashier',
			icon: <Home size={18} />,
		},
		{
			key: 'dashboard',
			label: 'Dashboard',
			path: '/analytics',
			icon: <LayoutDashboard size={18} />,
		},
		{
			key: 'groups',
			label: 'Groups',
			path: '/groups',
			icon: <Users2 size={18} />,
		},
		{
			key: 'members',
			label: 'Members',
			path: '/members',
			icon: <UserSquare2 size={18} />,
		},
		{
			key: 'loans',
			label: 'Loans',
			path: '/loans',
			icon: <HandCoins size={18} />,
		},
		{
			key: 'savings',
			label: 'Savings',
			path: '/savings',
			icon: <PiggyBank size={18} />,
		},
		{
			key: 'tellers',
			label: 'Tellers',
			path: '/tellers',
			icon: <UserCog size={18} />,
		},
		{
			key: 'marker_checker',
			label: 'Marker Checker',
			path: '/markercheckers',
			icon: <UserCheck size={18} />,
		},
		{
			key: 'accounting',
			label: 'Accounting',
			icon: <Banknote size={18} />,
			children: [
				{
					key: 'gl_transactions',
					label: 'GL Transactions',
					path: '/transactions',
					icon: <FileSpreadsheet size={18} />,
				},
				{
					key: 'create_journal_entry',
					label: 'Create JE',
					path: '/transactions/create_gl',
					icon: <FilePlus size={18} />,
				},
				{
					key: 'mpesa_reconciliation',
					label: 'Mpesa Recon',
					path: '/transactions/mpesa_recon',
					icon: <ReceiptText size={18} />,
				},
			],
		},
		{
			key: 'reports',
			label: 'Reports',
			icon: <FileText size={18} />,
			children: [
				{
					key: 'custom_reports',
					label: 'Reports',
					path: '/reports',
					icon: <ClipboardList size={18} />,
				},
				{
					key: 'bi_reports',
					label: 'BI Reports',
					path: '/bireports',
					icon: <LineChart size={18} />,
				},
			],
		},
		{
			key: 'admin',
			label: 'Admin',
			icon: <Cog size={18} />,
			children: [
				{
					key: 'admin_staff',
					label: 'Staff',
					path: '/staff',
					icon: <UserCog size={18} />,
				},
				{
					key: 'admin_roles',
					label: 'Roles',
					path: '/roles',
					icon: <ShieldCheck size={18} />,
				},
				{
					key: 'admin_users',
					label: 'Users',
					path: '/users',
					icon: <User size={18} />,
				},
				{
					key: 'admin_audits',
					label: 'Audits',
					path: '/audits',
					icon: <FileSearch size={18} />,
				},
				{
					key: 'admin_products',
					label: 'Products',
					path: '/products',
					icon: <Building2 size={18} />,
				},
			],
		},
		{
			key: 'settings',
			label: 'Settings',
			path: '/settings',
			icon: <Settings size={18} />,
		},
	];

	return { routes };
}
